export default __webpack_public_path__ + "static/media/dash-equest.7fa90ba9.svg";